const currency = {
	floatToEuro(priceInEuro) {
		return priceInEuro.toLocaleString('de-DE', {
			style: 'currency',
			currency: 'EUR',
			minimumFractionDigits: 2,
		});
	},
};

export { currency as default };
